import { gql } from '@apollo/client';
import {
  Questionnaire,
} from '../../../../components/Global/DansFundQuestionnaire/Common';

export const getQuestionnaireQuery = gql`
  query {
    dans_fund_questionnaire {
      id
      name
      questions
      send_to
    }
  }
`;

// Query relies on X-Hasura-Patient-Id session variable for row-level security
// No patientId variable needed - Hasura filters automatically based on the verified token
export const getPatientQuery = gql`
  query GetPatient {
    dans_fund_patients {
      id
      phone_number
      opted_out
    }
  }
`;

export interface GetQuestionnaireResponse {
  dans_fund_questionnaire: Questionnaire[];
}

export interface PatientData {
  id: string;
  phone_number: string;
  opted_out: boolean;
}

export interface GetPatientResponse {
  dans_fund_patients: PatientData[];
}
